import React from 'react';
import { FocusTrapZone } from 'focus-trap-zone';
import { getModalDiv, MODAL_DIV_ID, purgeModalDiv } from '../utils/modalDivUtils';
import { Modal } from './Modal';
import { ModalProps } from '../schema/ModalProps';
import { PortalWrapper } from 'portal-wrapper';
import { preventModalScroll } from 'prevent-modal-scroll';

const ScrollLockedModal = preventModalScroll(Modal, (component: any): HTMLDivElement => component);

/**
 * HOC to prevent the screen reader from going to background content
 */
const FocusTrappedModal: React.FC<ModalProps> = React.forwardRef(
    (props, ref?: React.RefObject<any>) => {
        const {
            elementToFocusOnOpen,
            elementToFocusOnClose,
            onOverlayClick,
            addAccessibleCloseButton,
            isScrollable,
            children,
        } = props;
        return (
            <FocusTrapZone
                id={MODAL_DIV_ID}
                focusOnOpen={elementToFocusOnOpen}
                focusOnClose={elementToFocusOnClose}>
                {isScrollable ? (
                    <ScrollLockedModal
                        ref={ref}
                        onOverlayClick={props.onOverlayClick}
                        addAccessibleCloseButton={props.addAccessibleCloseButton}>
                        {props.children}
                    </ScrollLockedModal>
                ) : (
                    <Modal
                        ref={ref}
                        onOverlayClick={onOverlayClick}
                        addAccessibleCloseButton={addAccessibleCloseButton}>
                        {children}
                    </Modal>
                )}
            </FocusTrapZone>
        );
    }
);

/**
 * Modal rendered inside React portal
 */
const ModalPortal: React.FC<ModalProps> = React.forwardRef(
    (props, ref?: React.RefObject<any>): JSX.Element => (
        <PortalWrapper divOrIdToAttachTo={getModalDiv()} onUnmount={purgeModalDiv}>
            <FocusTrappedModal {...props} ref={ref} />
        </PortalWrapper>
    )
);

export default ModalPortal;
